import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

const Icon = (props) => {
  return (
    <FontAwesomeIcon {...props} icon={faFilter} />
  );
}

export default Icon;
